/** HostPreviewCard 的常量与小工具(单独成文件:组件文件只导出组件,react-refresh 规则)。 */

/** 两档预览宽度(CSS px):桌面按常见 1280 宽排版,手机按 390(iPhone 14 一档)。 */
export const PREVIEW_DEVICES = {
  desktop: { label: "桌面", width: 1280, height: 800 },
  mobile: { label: "手机", width: 390, height: 780 },
} as const;
export type PreviewDevice = keyof typeof PREVIEW_DEVICES;

/** 这么久还没 load 就当嵌不进来(宿主挂了 / 网络拦了),给「打开站点」兜底。 */
export const PREVIEW_LOAD_TIMEOUT_MS = 20_000;

/** 只嵌 http(s) 地址。 */
export function embeddable(url: string | null | undefined): url is string {
  return !!url && /^https?:\/\//i.test(url.trim());
}
